import { render } from "./MessageImage.vue?vue&type=template&id=4266b108&scoped=true&ts=true"
import script from "./MessageImage.vue?vue&type=script&lang=ts"
export * from "./MessageImage.vue?vue&type=script&lang=ts"

import "./MessageImage.vue?vue&type=style&index=0&id=4266b108&lang=scss&scoped=true"

import exportComponent from "/var/www/widget.surveybot.me/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4266b108"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import TouchPan from 'quasar/src/directives/touch-pan/TouchPan.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QBtn});qInstall(script, 'directives', {TouchPan});
